import { format } from 'date-fns'

const StartedFinished = ({ dodone, includePreviousDate = true }) => {
  if ((!dodone.startedAt || !dodone.finishedAt) && !dodone.isIgnored)
    return null

  return (
    <div className="text-2xs digital-display frow gap-2 items-center">
      {includePreviousDate && dodone.isPrevious() && (
        <div>[{format(dodone.day, 'E, MMM do')}]</div>
      )}
      {dodone.startedAt && (
        <>
          {format(dodone.startedAt, 'HH:mm')}
          <i className="ph ph-arrow-right" />
        </>
      )}
      {dodone.finishedAt && <>{format(dodone.finishedAt, 'HH:mm')}</>}
    </div>
  )
}

export default StartedFinished
